import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import { trackSocialClick } from '../utils/analytics';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/yanivvds" target="_blank" rel="noreferrer" onClick={() => trackSocialClick('github')}><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/yanivvds/" target="_blank" rel="noreferrer" onClick={() => trackSocialClick('linkedin')}><LinkedInIcon/></a>
        <a href="mailto:yanivvds@gmail.com" onClick={() => trackSocialClick('email')}><EmailIcon/></a>
      </div>
      <p>A portfolio designed & built by <a href="https://github.com/yanivvds" target="_blank" rel="noreferrer" onClick={() => trackSocialClick('github')}>Yaniv van der Stigchel</a></p>
    </footer>
  );
}

export default Footer;